import React, { useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import AOS from 'aos'
import Text from '../../../../elements/Typo/Text'
import { ExperimentDetailsI } from '../../../../_config/types'
import { trackEvent } from '../../../../_common/functions'
import ExperimentReviewModal from '../../../CreateExperiment/ConfigureGroups/_components/modal/experimentReview.modal'
import { BodyTooltip } from '../../../../components/BodyTooltip'

interface Props {
    experiment: ExperimentDetailsI
    selectedGroup: string | null
    success?: () => void
}
const HypothesishSection: React.FC<Props> = ({ experiment, selectedGroup, success }) => {
    const { t } = useTranslation()
    const experimentDetailsViewModal: any = useRef()

    const _handleShowExperimentDetails = () => {
        trackEvent('experiment_details_hypothesis_more_details', { experiment_literal: experiment?.experiment_literal })
        experimentDetailsViewModal.current?.showModal()
    }

    useEffect(() => {
        AOS.init({
            once: false, // Animation occurs every time you scroll to the element
        })
        AOS.refresh()
    }, [])

    return (
        <div className="flex flex-col gap-y-1 pr-4" data-aos="zoom-in" data-aos-delay="200">
            <div>
                <Text size="sm" className="font-semibold truncate md:text-clip">
                    {t('Hypothesis :')}
                </Text>
                <Text size="xs" className="truncate" title={experiment?.hypothesis}>
                    {experiment?.hypothesis}
                </Text>
            </div>
            <div>
                <div className="flex justify-between">
                    <Text size="sm" className="font-semibold">
                        {t('Group Name')}
                    </Text>
                    <Text size="sm" className="font-semibold">
                        {t('Action Taken')}
                    </Text>
                </div>
                {experiment?.experiment_metadatas?.interventions[0]?.group_configs &&
                    experiment?.experiment_metadatas?.interventions[0]?.group_configs
                        .filter((data: any) => data?.is_control === true || data?.name === selectedGroup)
                        .map((data: any, index: number) => (
                            <div className="flex justify-between gap-3" key={data?.name + '_' + index}>
                                <Text className="font-normal !text-[0.458rem] truncate md:text-clip shrink-0">{data?.name}</Text>
                                <BodyTooltip text={data?.action} className="flex-grow truncate">
                                    <Text className="font-normal !text-[0.458rem]  truncate w-full text-end">{data?.action}</Text>
                                </BodyTooltip>
                            </div>
                        ))}
            </div>
            <div className="flex justify-center">
                <Text size="sm" className="underline cursor-pointer font-normal" onClick={_handleShowExperimentDetails}>
                    {t('Show More Details')}
                </Text>
            </div>
            <ExperimentReviewModal
                _ref={experimentDetailsViewModal}
                success={() => {
                    success?.()
                }}
                viewOnly={true}
            />
        </div>
    )
}
export default HypothesishSection
